/* @flow */
import { AgeGroup, Gender } from '../../../../../sushi/constants';

export const heatColorLevel = {
  '0': '#fff',
  '1': '#f8e4e8',
  '2': '#e8c4cf',
  '3': '#e2a1b6',
  '4': '#d88095',
  '5': '#b26478',
};

export const getSushiColor = function(value: number) {
  let color = '';

  if (value === 0) {
    return heatColorLevel['0'];
  }

  if (value >= 0.4) {
    return heatColorLevel['5'];
  }

  const pair = [
    { a: 0.01, b: 0.09 },
    { a: 0.1, b: 0.19 },
    { a: 0.2, b: 0.29 },
    { a: 0.3, b: 0.39 },
  ];

  pair.forEach((p, i) => {
    if (p.a <= value && value <= p.b) {
      color = heatColorLevel[i + 1];
      return;
    }
  });

  return color;
};

export const heatmapData = {
  [Gender.MALE]: {
    [AgeGroup.CHILD]: [
      { sushiName: 'サーモン', data: [0, 0, 0.233, 0, 0] },
      { sushiName: 'サバ', data: [0, 0, 0.1, 0, 0] },
      { sushiName: 'トロ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'エビ', data: [0.033, 0.8, 0, 0.266, 0] },
      { sushiName: 'タコ', data: [0.033, 0, 0.233, 0.266, 0.9] },
      { sushiName: 'タマゴ', data: [0.033, 0, 0.1, 0.266, 0] },
      { sushiName: 'イクラ', data: [0.3, 0, 0, 0.066, 0] },
      { sushiName: 'ウニ', data: [0.3, 0, 0, 0.066, 0] },
      { sushiName: 'コーン', data: [0.3, 0.2, 0.233, 0.066, 0.1] },
      { sushiName: 'かっぱ', data: [0, 0, 0.1, 0, 0] },
      { sushiName: 'かいせん', data: [0, 0, 0, 0, 0] },
      { sushiName: 'てまき', data: [0, 0, 0, 0, 0] },
    ],
    [AgeGroup.ADULT]: [
      { sushiName: 'サーモン', data: [0, 0, 0, 0, 0] },
      { sushiName: 'サバ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'トロ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'エビ', data: [0.033, 0, 0, 0.266, 0] },
      { sushiName: 'タコ', data: [0.033, 0.8, 0, 0.266, 0] },
      { sushiName: 'タマゴ', data: [0.033, 0, 0.35, 0.266, 0.9] },
      { sushiName: 'イクラ', data: [0.3, 0, 0.15, 0.066, 0.1] },
      { sushiName: 'ウニ', data: [0.3, 0, 0, 0.066, 0] },
      { sushiName: 'コーン', data: [0.3, 0, 0, 0.066, 0] },
      { sushiName: 'かっぱ', data: [0, 0, 0.35, 0, 0] },
      { sushiName: 'かいせん', data: [0, 0, 0.15, 0, 0] },
      { sushiName: 'てまき', data: [0, 0.2, 0, 0, 0] },
    ],
    [AgeGroup.MIDDLE_AGE]: [
      { sushiName: 'サーモン', data: [0, 0, 0, 0, 0] },
      { sushiName: 'サバ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'トロ', data: [0, 0.2, 0.233, 0, 0] },
      { sushiName: 'エビ', data: [0.033, 0, 0.1, 0.266, 0.9] },
      { sushiName: 'タコ', data: [0.033, 0, 0, 0.266, 0] },
      { sushiName: 'タマゴ', data: [0.033, 0, 0, 0.266, 0] },
      { sushiName: 'イクラ', data: [0.3, 0, 0.233, 0.066, 0.1] },
      { sushiName: 'ウニ', data: [0.3, 0, 0.1, 0.066, 0] },
      { sushiName: 'コーン', data: [0.3, 0, 0, 0.066, 0] },
      { sushiName: 'かっぱ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'かいせん', data: [0, 0.8, 0.233, 0, 0] },
      { sushiName: 'てまき', data: [0, 0, 0.1, 0, 0] },
    ],
  },
  [Gender.FEMALE]: {
    [AgeGroup.CHILD]: [
      { sushiName: 'サーモン', data: [0.033, 0, 0.35, 0.266, 0.9] },
      { sushiName: 'サバ', data: [0.033, 0, 0.1, 0.266, 0] },
      { sushiName: 'トロ', data: [0.033, 0.2, 0, 0.266, 0] },
      { sushiName: 'エビ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'タコ', data: [0, 0, 0.35, 0, 0] },
      { sushiName: 'タマゴ', data: [0, 0.8, 0.1, 0, 0] },
      { sushiName: 'イクラ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'ウニ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'コーン', data: [0, 0, 0, 0, 0] },
      { sushiName: 'かっぱ', data: [0.3, 0, 0.1, 0.066, 0.1] },
      { sushiName: 'かいせん', data: [0.3, 0, 0, 0.066, 0] },
      { sushiName: 'てまき', data: [0.3, 0, 0, 0.066, 0] },
    ],
    [AgeGroup.ADULT]: [
      { sushiName: 'サーモン', data: [0.033, 0, 0, 0.266, 0] },
      { sushiName: 'サバ', data: [0.033, 0, 0.233, 0.266, 0.9] },
      { sushiName: 'トロ', data: [0.033, 0, 0.1, 0.266, 0] },
      { sushiName: 'エビ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'タコ', data: [0, 0.8, 0, 0, 0] },
      { sushiName: 'タマゴ', data: [0, 0, 0.233, 0, 0] },
      { sushiName: 'イクラ', data: [0, 0, 0.1, 0, 0] },
      { sushiName: 'ウニ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'コーン', data: [0, 0.2, 0, 0, 0] },
      { sushiName: 'かっぱ', data: [0.3, 0, 0.233, 0.066, 0.1] },
      { sushiName: 'かいせん', data: [0.3, 0, 0.1, 0.066, 0] },
      { sushiName: 'てまき', data: [0.3, 0, 0, 0.066, 0] },
    ],
    [AgeGroup.MIDDLE_AGE]: [
      { sushiName: 'サーモン', data: [0.033, 0, 0, 0.266, 0] },
      { sushiName: 'サバ', data: [0.033, 0, 0, 0.266, 0] },
      { sushiName: 'トロ', data: [0.033, 0, 0.233, 0.266, 0.9] },
      { sushiName: 'エビ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'タコ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'タマゴ', data: [0, 0, 0, 0, 0] },
      { sushiName: 'イクラ', data: [0, 0.8, 0.233, 0, 0] },
      { sushiName: 'ウニ', data: [0, 0, 0.15, 0, 0] },
      { sushiName: 'コーン', data: [0, 0, 0, 0, 0] },
      // prettier-ignore
      { sushiName: 'かっぱ', data: [0.3, 0.2, 0, 0.066, 0] },
      { sushiName: 'かいせん', data: [0.3, 0, 0.233, 0.066, 0.1] },
      { sushiName: 'てまき', data: [0.3, 0, 0.15, 0.066, 0] },
    ],
  },
};

export const commentData = {
  [Gender.MALE]: {
    [AgeGroup.CHILD]: [
      { content: '2皿目は、エビを食べることが多いなぁ。' },
      { content: 'サーモンとタコとコーンは、安くておいしいからなやんじゃう。' },
      { content: '最後は、やっぱりタコだよね。' },
      { content: '1皿目は、やっぱりぐんかんがいいな。' },
      { content: 'ぐんかんを食べたら、最後はタマゴを選ぶよ。' },
      { content: 'エビとコーンで、いつもなやんじゃう。' },
    ],
    [AgeGroup.ADULT]: [
      { content: '2皿目は、タコを食べることが多いね。' },
      { content: 'イクラとかいせんは、おいしいけど少し高いなぁ。' },
      { content: 'ぐんかんを食べたら、最後はやっぱりタマゴだよね。' },
      { content: '1皿目は、ぐんかんだよね。' },
      { content: '全然食べなかった種類もあったなー。' },
      { content: 'タコとてまきで、いつもなやむんだ。' },
    ],
    [AgeGroup.MIDDLE_AGE]: [
      { content: '2皿目は、かいせんを食べることが多いね。' },
      { content: 'エビとウニとてまきは、おいしいけど少し高いね。' },
      { content: '最後は、やっぱりエビだね。' },
      { content: '1皿目は、ぐんかんが多いかな。' },
      { content: '1皿目に選ぶ種類で、最後に選ぶのを決めてるよ。' },
      { content: 'トロとかいせんで、いつもなやんじゃうね。' },
    ],
  },
  [Gender.FEMALE]: {
    [AgeGroup.CHILD]: [
      { content: '2皿目は、タマゴを食べることが多いなぁ。' },
      { content: 'サーモンとタコは安くておいしいから好き。' },
      { content: '最後は、サーモンを選んじゃう。' },
      { content: '1皿目は、やっぱりまき物がいいな。' },
      { content: 'トロとタマゴで、いつもなやんじゃう。' },
      { content: '全然食べなかった種類もあったよ。' },
    ],
    [AgeGroup.ADULT]: [
      { content: '2皿目は、タコを食べることが多いですね。' },
      { content: 'なやんだら、値段が安い方を選びますね。' },
      { content: 'かいせんを食べたら、最後はサバを選びますね。' },
      { content: '1皿目は、まき物を選ぶことが多いですね。' },
      { content: '1皿目に選んだ種類で、最後の1皿を決めてます。' },
      { content: 'タコとコーンで、いつもなやみますね。' },
    ],
    [AgeGroup.MIDDLE_AGE]: [
      { content: '2皿目は、イクラを食べることが多いわね。' },
      { content: 'なやんだら、値段が安い方を選びますね。' },
      { content: '最後は、トロをえらぶことが多いわね。' },
      { content: '1皿目は、やっぱりまき物ですよね。' },
      { content: 'まき物を食べたら、最後はトロを選んじゃうわね。' },
      { content: 'イクラかかっぱで、いつもなやんじゃうわね。' },
    ],
  },
};

export const eatenSushiData = {
  [Gender.MALE]: {
    [AgeGroup.CHILD]: [
      ['3-3', '2-1', '3-3', '2-1', '2-2'],
      ['3-2', '3-3', '2-2', '2-3', '2-2'],
      ['3-3', '2-1', '3-3', '2-2', '2-2'],
      ['3-3', '2-1', '1-1', '2-1', '2-2'],
      ['3-1', '2-1', '3-3', '2-3', '2-2'],
      ['2-3', '3-3', '1-2', '2-2', '3-3'],
      ['3-3', '2-1', '1-1', '3-3', '2-2'],
      ['3-3', '2-1', '2-2', '2-2', '2-2'],
      ['3-1', '2-1', '4-1', '2-3', '2-2'],
      ['3-2', '2-1', '2-3', '3-1', '2-2'],
    ],
    [AgeGroup.ADULT]: [
      ['3-1', '2-2', '3-1', '2-1', '2-3'],
      ['2-1', '2-2', '2-3', '2-2', '3-1'],
      ['3-2', '2-2', '4-1', '2-1', '2-3'],
      ['2-2', '2-2', '4-1', '3-2', '3-1'],
      ['3-1', '2-2', '4-2', '2-3', '2-3'],
      ['3-1', '2-2', '4-2', '2-1', '2-3'],
      ['3-3', '2-2', '4-1', '2-1', '2-3'],
      ['3-1', '2-2', '2-3', '2-3', '2-3'],
      ['3-2', '4-3', '2-3', '2-2', '2-3'],
      ['3-3', '4-3', '4-1', '3-1', '2-3'],
    ],
    [AgeGroup.MIDDLE_AGE]: [
      ['2-2', '4-2', '4-2', '2-2', '3-1'],
      ['3-3', '4-2', '1-3', '2-3', '2-1'],
      ['3-1', '1-3', '3-2', '2-2', '2-1'],
      ['3-3', '4-2', '3-1', '3-2', '2-1'],
      ['2-1', '1-3', '3-1', '2-1', '3-1'],
      ['3-1', '4-2', '1-3', '2-1', '2-1'],
      ['3-1', '4-2', '4-2', '2-2', '2-1'],
      ['3-3', '4-2', '2-1', '2-1', '2-1'],
      ['3-2', '4-2', '4-3', '3-3', '2-1'],
      ['3-2', '4-2', '1-3', '2-3', '2-1'],
    ],
  },
  [Gender.FEMALE]: {
    [AgeGroup.CHILD]: [
      ['4-1', '1-3', '2-2', '1-1', '1-1'],
      ['4-1', '2-3', '2-2', '1-3', '1-1'],
      ['4-2', '1-3', '4-1', '1-3', '1-1'],
      ['4-2', '2-3', '1-1', '4-3', '1-1'],
      ['4-3', '2-3', '1-2', '1-2', '1-1'],
      ['4-1', '2-3', '2-2', '4-2', '1-1'],
      ['1-1', '2-3', '1-1', '1-1', '4-1'],
      ['1-3', '2-3', '2-3', '1-2', '4-1'],
      ['4-3', '2-3', '1-1', '1-1', '1-1'],
      ['4-2', '2-3', '1-1', '1-1', '1-1'],
    ],
    [AgeGroup.ADULT]: [
      ['1-1', '2-2', '4-2', '1-2', '4-1'],
      ['4-1', '2-2', '1-2', '4-3', '1-2'],
      ['4-2', '3-3', '4-1', '1-3', '1-2'],
      ['4-1', '2-2', '1-3', '1-2', '1-2'],
      ['1-1', '2-2', '2-3', '1-2', '4-1'],
      ['4-3', '2-2', '1-2', '1-3', '1-2'],
      ['4-3', '2-2', '3-1', '1-2', '1-2'],
      ['4-1', '2-2', '2-3', '1-1', '1-2'],
      ['4-2', '2-2', '2-3', '4-1', '1-2'],
      ['4-1', '3-3', '4-1', '1-1', '1-2'],
    ],
    [AgeGroup.MIDDLE_AGE]: [
      ['4-1', '3-1', '4-2', '4-3', '1-3'],
      ['1-2', '4-1', '1-3', '1-1', '4-2'],
      ['4-3', '3-1', '4-2', '1-3', '1-3'],
      ['4-1', '3-1', '3-2', '1-1', '1-3'],
      ['4-3', '3-1', '4-2', '1-2', '1-3'],
      ['1-3', '3-1', '3-2', '1-1', '4-2'],
      ['4-1', '3-1', '3-1', '4-2', '1-3'],
      ['4-3', '3-1', '4-3', '1-3', '1-3'],
      ['4-2', '4-1', '1-3', '1-2', '1-3'],
      ['4-2', '3-1', '3-1', '1-2', '1-3'],
    ],
  },
};
